import type Client from '../client'
import type { ErrorAble } from '@/api'
import type { Market } from '@/market'

export type MarketsResponse = {
  data: Market[];
}

export default class MarketResource {
  constructor(private client: Client) {}

  all(): Promise<ErrorAble<MarketsResponse>> {
    return this.client.get('markets')
  }
}
